import { getAnalytics, logEvent } from "firebase/analytics";
import * as Sentry from "@sentry/react";

const CONSENT_KEY = 'superasso_cookie_consent';
const SIX_MONTHS_MS = 182 * 24 * 60 * 60 * 1000;

let analytics = null;

/**
 * Récupère le consentement stocké ou null s'il n'existe pas ou est expiré.
 */
export const getStoredConsent = () => {
    try {
        const item = localStorage.getItem(CONSENT_KEY);
        if (!item) return null;

        const { consent, timestamp } = JSON.parse(item);
        const now = Date.now();

        if (now - timestamp > SIX_MONTHS_MS) {
            localStorage.removeItem(CONSENT_KEY);
            return null;
        }

        return consent;
    } catch (e) {
        console.error("[Tracking] Erreur lecture consentement:", e);
        return null;
    }
};

/**
 * Enregistre le consentement.
 */
export const saveConsent = (consent) => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
        consent,
        timestamp: Date.now()
    }));
};

/**
 * Initialise les services de tracking selon le consentement.
 */
export const initTracking = (consent, app) => {
    if (!consent) return;

    // 1. Firebase Analytics
    if (consent.analytics && app) {
        try {
            analytics = getAnalytics(app);
            console.log("[Tracking] Firebase Analytics initialisé.");
        } catch (e) {
            console.error("[Tracking] Erreur init Analytics:", e);
        }
    }

    // 2. Microsoft Clarity - SUPPRIMÉ
    
    // 3. Sentry Replay - SUPPRIMÉ
};

/**
 * Log un événement Firebase si le consentement a été donné.
 */
export const logTrackingEvent = (name, params) => {
    if (analytics) {
        logEvent(analytics, name, params);
    } else {
        // En mode dev ou si refusé, on peut logger dans la console
        if (import.meta.env.DEV) {
            console.log(`[Tracking Event - Bypass] ${name}`, params);
        }
    }
};
